import { useEffect } from "react";

import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useDispatch } from "react-redux";

import { NOTIFICATION_CONFIG } from "./config";
import { resolveDuration } from "./constants";
import { removeNotification } from "./NotificationsSlice";
import {
  DismissButton,
  IconWrapper,
  ProgressBar,
  Row,
  TextWrapper,
} from "./styles";
import { Notification } from "./types";

export const NotificationCard: React.FC<Notification> = ({
  type,
  message,
  id,
  duration,
}) => {
  const dispatch = useDispatch();
  const config = NOTIFICATION_CONFIG[type];
  const effectiveDuration = resolveDuration(type, duration);
  const isSticky = effectiveDuration === 0;

  useEffect(() => {
    if (isSticky) {
      return;
    }
    const timer = setTimeout(
      () => dispatch(removeNotification(id)),
      effectiveDuration,
    );
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const remove = () => {
    dispatch(removeNotification(id));
  };

  const { Wrapper, Icon, role, ariaLive, label } = config;

  return (
    <Wrapper key={id} role={role} aria-live={ariaLive} aria-label={label}>
      <Row>
        <IconWrapper aria-hidden="true">
          <Icon />
        </IconWrapper>
        <TextWrapper>{message}</TextWrapper>
        <DismissButton
          size="large"
          onClick={remove}
          aria-label="Dismiss notification"
        >
          <HighlightOffIcon />
        </DismissButton>
      </Row>
      {!isSticky && <ProgressBar $duration={effectiveDuration} />}
    </Wrapper>
  );
};
